import { TelemetryInitializerFunction } from '@microsoft/applicationinsights-core-js';

export const cloudRoleNameTelemetryInitializer: (value: string) => TelemetryInitializerFunction = value => envelope => {
  envelope.tags!['ai.cloud.role'] = value;
};
